import { getExternalToken } from '../local';
import { fetchData, objectToQueryString, useCustomQuery } from './functions';
let getToken = () => {
    return getExternalToken(APP.store);
};
// (테스트 및 과제) 리스트 조회
export const getAssignmentList = async (queryString) => {
    const url = `/api/mimac/v1/tests?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 점수 현황 조회
export const getScoreStatus = async ({ id, queryString }) => {
    const url = `/api/mimac/v1/tests/${id}/score-status?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 성적 조회
export const getStatistics = async ({ test_id, queryString }) => {
    const url = `/api/mimac/v1/tests/${test_id}/statistics?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 질문 조회
export const getQuestionList = async (queryString) => {
    const url = `/api/mimac/v1/questions?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 제출 현황 조회
export const getSubmitStatus = async (data) => {
    const queryString = objectToQueryString(data.props); // props를 쿼리 문자열로 변환
    const url = `/api/mimac/v1/tests/${data.id}/submit-status?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 제출 현황 조회
export const getLoadAnswer = async (data) => {
    const queryString = objectToQueryString(data.props); // props를 쿼리 문자열로 변환
    const url = `/api/mimac/v1/tests/${data.id}/load-answer?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (회의실) conference 리스트 조회
const getConferenceList = async (queryString) => {
    const url = `/api/mimac/v1/conferences?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 풀이 조회
export const getAnswerList = async (queryString) => {
    const url = `/api/mimac/v1/answers?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 리스트 삭제
export const startTimer = async ({ id, duration }) => {
    const url = `/api/mimac/v1/tests/${id}/timer`;
    // duration 있음(강사, 비-모의고사) → 전체 타이머 시작.
    // duration 없음(학생, 모의고사) → 개별 타이머 시작.
    return fetchData(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(duration !== undefined ? { duration } : {}),
    });
};
// (모의고사) 개별 타이머 시작(idempotent) — 학생이 실제 문항/첨부파일을 처음 확인한 시점에 호출.
// sessionStorage 표식이 없을 때만 startTimer(body 없음)를 호출해 재진입/재클릭(새로고침 포함) 시
// 개별 타이머 리셋을 방지한다. 시작 성공/기존 시작 여부를 boolean 으로 반환.
export const startPersonalTimer = async ({ id }) => {
    const startedKey = `mock_personal_timer:${id}`;
    let started = false;
    try {
        started = sessionStorage.getItem(startedKey) === '1';
    }
    catch (e) { }
    if (started)
        return false;
    // startTimer 완료를 기다린 뒤 표식 → red_time과 풀이화면 타이머가 같은 개별 타이머 값을 받아 불일치 방지.
    await startTimer({ id });
    try {
        sessionStorage.setItem(startedKey, '1');
    }
    catch (e) { }
    return true;
};
// (모의고사) 개별 타이머 일시정지 — 강의실 퇴장 시 호출. request body 없음.
export const pauseTimer = async (id) => {
    const url = `/api/mimac/v1/tests/${id}/timer/pause`;
    // keepalive: 페이지 언로드(탭 닫기/이동) 중에도 요청이 전송되도록. noAlert: 언로드 중 alert 방지.
    return fetchData(url, {
        method: 'POST',
        keepalive: true,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    }, true);
};
// (테스트 및 과제) 질문 출제 등록
// 최종 제출 성공을 opener(mimac 창)에 알려 학생 테스트 목록을 실시간 갱신시킨다.
// (mimac이 meetmate를 window.open 팝업으로 띄우므로 window.opener = mimac 창)
const notifyMimacSubmitted = (test_id) => {
    try {
        if (typeof window !== 'undefined' && window.opener && !window.opener.closed) {
            window.opener.postMessage({ type: 'MIMAC_TEST_SUBMITTED', test_id }, '*');
        }
    }
    catch (e) { }
};
// 학생이 제출완료 화면에서 '성적표 보기'를 누르면 opener(mimac 창)에 통지해
// 해당 테스트의 성적표 상세(ScoreReportViewer)로 이동시킨다. notifyMimacSubmitted 와 동일 패턴.
// (mimac 이 meetmate 를 window.open 팝업으로 띄우므로 window.opener = mimac 창)
// 성적표 PDF 뷰어는 mimac 에만 있으므로, meetmate 는 신호만 보내고 mimac 창을 포커싱한다.
// opener 가 없거나 닫혔으면(직접 진입 등) 안전하게 무시한다 → 반환값으로 호출부가 분기 가능.
export const notifyMimacOpenScoreReport = (test_id) => {
    try {
        if (typeof window !== 'undefined' && window.opener && !window.opener.closed) {
            window.opener.postMessage({ type: 'MIMAC_OPEN_SCORE_REPORT', test_id }, '*');
            try {
                window.opener.focus();
            }
            catch (e) { }
            return true;
        }
    }
    catch (e) { }
    return false;
};
// 학생이 제출완료 화면에서 '성적표 보기'를 누르면 opener(mimac 창)에 성적표 PDF 생성을 요청한다.
// mimac 이 기존 생성기로 PDF 를 만들어 MIMAC_SCORE_PDF_DATA(바이트)로 회신하면, 호출부(OmrContainer)가
// 이 팝업 안에서 렌더한다. (성적표 PDF 생성기는 mimac 에만 존재 → meetmate 는 요청만 하고 결과 바이트를 그린다.
//  창 이동/포커스 없음 — 팝업 안 표시가 목적.) opener 가 없거나 닫혔으면 false 반환 → 호출부가 에러 처리.
export const requestMimacScorePdf = (test_id) => {
    try {
        if (typeof window !== 'undefined' && window.opener && !window.opener.closed) {
            window.opener.postMessage({ type: 'MIMAC_REQUEST_SCORE_PDF', test_id }, '*');
            return true;
        }
    }
    catch (e) { }
    return false;
};
// ★중복 최종제출 원천 차단(초크포인트): 같은 test_id 로 진행 중인 submit-answer 요청이 있으면
// 새 fetch 를 만들지 않고 진행 중인 Promise 를 그대로 공유한다. 서버 dedup(DB 존재 확인)은
// 0.06초 간격 동시 요청을 거르지 못하므로 클라이언트가 발사 자체를 병합해야 한다
// (강제제출(WS)×자동제출(폴링)×수동제출 경합 대비). reject 방식 금지 — 후발 호출자의 catch 가
// 사용자에게 오류 알림을 띄우게 된다. Promise 공유면 양쪽 모두 동일한 성공/실패를 보고
// 각자의 멱등 후속 처리를 진행한다. 완료(성공/실패) 시 맵에서 제거.
const submitAnswerInFlight = new Map();
export const postSubmitAnswer = async (data) => {
    // 동기 가드 — 같은 태스크 내 이중 발화(더블클릭 합성 등)도 첫 요청으로 병합된다.
    const inFlight = submitAnswerInFlight.get(data.id);
    if (inFlight)
        return inFlight;
    const request = (async () => {
        const url = `/api/mimac/v1/tests/${data.id}/submit-answer`;
        const res = await fetchData(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data.props),
        }, true, 
        // ★최종 제출은 유실되면 안 된다 — 기본 15s 타임아웃 대신 넉넉한 상한(60s)
        60000);
        // 최종 제출 성공 시 opener(mimac 창)에 통지 → 학생 테스트 목록 실시간 갱신(공유 시 1회만 발화)
        notifyMimacSubmitted(data.id);
        return res;
    })();
    // 첫 await 이전 = 동기 등록 — 60ms 레이스는 물론 같은 태스크 내 재호출도 이 맵에 걸린다.
    submitAnswerInFlight.set(data.id, request);
    try {
        return await request;
    }
    finally {
        // 성공/실패 모두 제거 — 실패 후 재시도(자동제출 800ms 재시도 루프 등)는 새 요청을 만든다(정상).
        submitAnswerInFlight.delete(data.id);
    }
};
// (테스트 및 과제) 답안 임시저장
// opts.keepalive: 페이지 언로드(탭 닫기/이동) 중에도 요청이 전송되도록 (pauseTimer 와 동일 패턴)
export const postSaveSubmitAnswer = async (data, opts) => {
    const url = `/api/mimac/v1/tests/${data.id}/save-answer`;
    return fetchData(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props),
        ...(opts?.keepalive ? { keepalive: true } : {}),
    }, true, 
    // ★임시저장도 유실 방지 우선 — 넉넉한 상한(60s). keepalive 요청은 fetchData 가 abort 미적용
    60000);
};
// (account) 사용자 정보 조회 -useUserInfo
export const postVerifyToken = async (props) => {
    const url = `/api/mimac/user/v1/verify-auth-token`;
    return fetchData(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${props.access_token}`,
        },
        // body: JSON.stringify(props),
    });
};
// (테스트 및 과제) 성적 조회
export const getGrades = async (queryString) => {
    const url = `/api/mimac/v1/grades?${queryString}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 예상 등급컷 조회 — mimac getTierCutoff 와 동일 엔드포인트.
// 성적 데이터(컷오프) 업로드 여부의 신뢰 신호: result.items 가 비어있으면 미등록, 1개 이상이면 등록됨.
// member_id 는 선택(서버 명세상 optional) — 컷오프는 테스트 단위 업로드 산출물이라 test id 만으로 조회 가능.
export const getTierCutoff = async (id, member_id) => {
    const query = member_id ? `?member_id=${encodeURIComponent(member_id)}` : '';
    const url = `/api/mimac/v1/tests/${id}/tier-cutoff${query}`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 질문 가져오기
export const useAnswerList = (data) => {
    const queryString = objectToQueryString(data);
    return useCustomQuery(['answer', queryString], () => getAnswerList(queryString));
}; // (테스트 및 과제) 질문 가져오기
export const useQuestionList = (data) => {
    const queryString = objectToQueryString(data);
    return useCustomQuery([`question`, queryString], () => getQuestionList(queryString));
};
// (테스트 및 과제) 점수 현황 가져오기
export const useSubmitStatus = (data) => {
    const queryString = objectToQueryString(data);
    return useCustomQuery([`submit_status`, queryString], () => getSubmitStatus(data));
};
// (테스트 및 과제) 리스트 가져오기
export const useAssignmentList = (data) => {
    const queryString = objectToQueryString(data); // props를 쿼리 문자열로 변환
    return useCustomQuery([`assignment_${data}`, data], () => getAssignmentList(queryString));
};
// (회의실) conference 리스트 조회 -useConferenceList
export const useConferenceList = (data) => {
    const queryString = objectToQueryString(data); // props를 쿼리 문자열로 변환
    return useCustomQuery(`conferences_${queryString}`, () => getConferenceList(queryString));
};
// 테스트 임시저장 불러오기
export const useLoadAnswer = (data) => {
    const queryString = objectToQueryString(data);
    return useCustomQuery(`loadAnswer_${queryString}`, () => getLoadAnswer({ id: data.id, props: data.props }));
};
// (테스트 및 과제) 성적 가져오기
export const useGradesList = (data) => {
    const queryString = objectToQueryString(data);
    return useCustomQuery(`grades_${queryString}`, () => getGrades(queryString));
};
// (테스트 및 과제) 통계 가져오기
export const useStatistics = (data) => {
    const queryString = objectToQueryString(data);
    return useCustomQuery(`statistics_${queryString}`, () => getStatistics({ test_id: data.test_id, queryString }));
};
// (테스트 및 과제) 점수 현황 가져오기
export const useScoreStatus = (data) => {
    const queryString = objectToQueryString(data);
    return useCustomQuery([`score_${data}`, data], () => getScoreStatus({ id: data.id, queryString }));
};
// 대기열 조회
export const getLiveEnquiries = async (queryString) => {
    const url = `/api/mimac/v1/enquiries?${queryString}`; // API 엔드포인트 생성
    // 폴링성 조회 — 실패/타임아웃마다 알럿이 뜨면 스팸이 되므로 무알럿
    return fetchData(url, undefined, true);
};
export const useLiveEnquiries = (data) => {
    const queryString = objectToQueryString(data);
    return useCustomQuery([`live_${data}`, data], () => getLiveEnquiries(queryString));
};
// 대기열 등록 수락
export const postEnquiries = async (id) => {
    const url = `/api/mimac/v1/enquiries/${id}/queue-pop`;
    return fetchData(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
// (회의실) 1:1 라이브 대기열 해제
export const postoutEnquiriesList = async (id) => {
    const url = `/api/mimac/v1/enquiries/${id}/queue-out`;
    return fetchData(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
export const getTestTime = async (id) => {
    const url = `/api/mimac/v1/tests/${id}/timer`;
    // 인증 토큰 전달: 서버가 토큰으로 개별 타이머(모의고사) 보유 여부를 판별해
    // 개별 타이머가 있으면 그 남은 시간, 없으면 전체 타이머 기준으로 응답한다.
    return fetchData(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
// (파일) 파일 업로드
export const postAttachment = async (file, filepath) => {
    const url = `/api/mimac/file`; // API 엔드포인트 생성
    const formData = new FormData();
    formData.append('file', file); // Add the file
    formData.append('filepath', filepath); // Add the filepath
    const options = {
        method: 'POST',
        body: formData,
    };
    // ★파일첨부형 답안 업로드 — 유실되면 안 되는 쓰기 + 대용량 가능성. 기본 15s 대신 넉넉한 상한(120s)
    return fetchData(url, options, undefined, 120000);
};
// (테스트 및 과제) 설문 빈도 조회
export const getSurveyFrequency = async (test_id) => {
    const url = `/api/mimac/v1/tests/${test_id}/frequencies`; // API 엔드포인트 생성
    return fetchData(url);
};
// (테스트 및 과제) 설문 빈도 조회
export const useSurveyFrequency = (data) => {
    // @ts-ignore
    const queryString = objectToQueryString(data);
    return useCustomQuery(['frequencies', data], () => getSurveyFrequency(queryString));
};
